<template>
  <cq-master>
    <section class="about">
      <ab-carousel></ab-carousel>
      <ab-colloquim></ab-colloquim>
      <ab-gain></ab-gain>
      <ab-whatColloquium></ab-whatColloquium>
      <ab-proof></ab-proof>
      <ab-work></ab-work>
      <ab-stages></ab-stages>
    </section>
  </cq-master>
</template>

<script>
import CQMaster from '@/components/layout/CQMaster.vue';
import ABCarousel  from '../components/About/AB-Carousel';
import ABColloquim  from '../components/About/AB-Colloquim';
import ABGain  from '../components/About/AB-Gain';
import ABProof from '../components/About/AB-Proof';
import ABWhatTheColloquium from '../components/About/AB-WhatTheColloquium';
import ABWork from '../components/About/AB-Work';
import ABStages from '../components/About/AB-Stages';
export default {
  name: 'about',
  components: {
    'cq-master' : CQMaster,
    'ab-carousel':ABCarousel,
    'ab-colloquim':ABColloquim,
    'ab-gain':ABGain,
    'ab-proof':ABProof,
    'ab-whatColloquium':ABWhatTheColloquium,
    'ab-work':ABWork,
    'ab-stages': ABStages
  }
}
</script>